import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c6c2e8f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-video-priviewer"
};
const _hoisted_2 = {
  class: "c-video-priviewer-containner"
};
const _hoisted_3 = ["src", "poster", "muted"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _directive_touch = _resolveDirective("touch");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: $data.visible,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.visible = $event),
    style: {
      "padding": "0",
      "width": "100vw",
      "height": "100vh"
    }
  }, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [$data.visible && $props.src ? (_openBlock(), _createElementBlock("video", {
      key: 0,
      class: "c-video-priviewer-player",
      src: $props.src,
      controls: "",
      autoplay: "",
      "webkit-playsInline": "true",
      "x5-playsInline": "true",
      playsInline: "true",
      "x5-video-player-type": "h5-page",
      "x5-video-player-fullscreen": false,
      poster: $props.poster,
      muted: $props.muted
    }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createVNode(_component_svg_icon, {
      class: "c-video-priviewer-close",
      "icon-class": "close",
      onClick: _cache[0] || (_cache[0] = $event => $data.visible = false)
    })])), [[_directive_touch, $options.handlePress, "press"]])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_action_sheet, {
    show: $data.showAction,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.showAction = $event),
    actions: $data.actions,
    "cancel-text": this.$t('cfmoto.cancel'),
    "close-on-click-action": "",
    onCancel: $options.onCancel,
    onSelect: $options.onSelect
  }, null, 8, ["show", "actions", "cancel-text", "onCancel", "onSelect"])]);
}